import React, { useEffect } from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line
import { HypeTimer } from "../ui";
import { ErrorMessage, Spinner } from "../elements";
import { AnalyticsEvent } from "../../components/elements/analytics-event";
const HypeTrain = (props) => {
  useEffect(() => {
    /* Remove for production */
    const url = `${process.env.REACT_APP_LOCAL_URI}/hypetrain/`;
    /* Remove for production */

    let streamer = window.location.href.replace(url, "").split("/");
    if (streamer[0][0] === "@" || streamer[0][0] === "+") {
      streamer[2] = streamer[0][0];
      streamer[0] = streamer[0].substr(1, streamer[0].length);
    } else {
      streamer[2] = "@";
    }

    if (streamer[0] !== "") {
      let streamType = streamer[2],
        username = streamer[0],
        slug = streamer[1];

      /* Remove for production */
      props.overlayStore.socketConnect(streamType, username, slug);

      return () => props.overlayStore.socketDisconnect();
    }
  }, []);

  const { error, isLoading } = props.overlayStore;
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const difficulty = urlParams.get("difficulty");
  const settings = {
    difficulty: difficulty,
    percentageIncrease: difficulty === "medium" ? 35 : 20,
  };

  return error ? (
    <ErrorMessage>THERE HAS BEEN AN ERROR.</ErrorMessage>
  ) : isLoading ? (
    <Spinner />
  ) : (
    <div className="hype_wrap">
      {AnalyticsEvent("english", "/", "PLAY LIVE Hype Overlay")}
      {<HypeTimer settings={settings} />}
    </div>
  );
};

export default inject("overlayStore")(observer(HypeTrain));
